// extracted by mini-css-extract-plugin
export default {"topbarWrapper":"BRuk8Zdg","logoText":"FnAjwMRx","navSection":"tlAVdIId","navOption":"pfB4qqXy"};